import React from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  Grid,
  Paper,
  IconButton,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";

const PRIMARY = "#CC0000";

const newsItems = [
  {
    date: "2024.11.1",
    category: "メディア",
    title: "MTT大会のシステム支援を実施。",
  },
  {
    date: "2024.6.10",
    category: "メディア",
    title: "ココナスポーツクラブの管理システム支援を開始。",
  },
  {
    date: "2024.04.24",
    category: "メディア",
    title: "TriArrows合同会社を設立。SNS採用事業、SNS動画制作事業、DX支援事業を開始。",
  },
];

const businessItems = [
  {
    label: "IT事業",
    title: "システム開発・保守・運用",
    description:
      "独自の開発アプローチと情報設計により、拡張性と操作性に優れたシステムを構築。長期パートナーとして開発・保守・運用を一貫して支援します。",
    icon: "💻",
  },
  {
    label: "SNS事業",
    title: "SNS採用 / SNS運用",
    description:
      "企業の魅力を最大限に引き出し、集客・採用に直結させるSNS戦略を提供。「認知」から「流入・問い合わせ」への最大化を実現します。",
    icon: "📱",
  },
];

const TopPage = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ backgroundColor: "#fff" }}>
      {/* Hero Section */}
      <Box
        sx={{
          position: "relative",
          bgcolor: PRIMARY,
          color: "white",
          minHeight: { xs: "60vh", md: "80vh" },
          display: "flex",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        {/* 背景画像（あれば） */}
        <Box
          component="img"
          src="/hero.jpeg"
          alt=""
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: 0.15,
            zIndex: 0,
          }}
        />
        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1, py: { xs: 8, md: 12 } }}>
          <Typography
            sx={{
              fontSize: { xs: "0.85rem", md: "1rem" },
              fontWeight: 600,
              letterSpacing: 3,
              mb: 2,
              opacity: 0.9,
            }}
          >
            Mission
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontWeight: 900,
              fontSize: { xs: "2rem", md: "3.5rem" },
              lineHeight: 1.3,
              mb: 4,
            }}
          >
            ITの力で社会の課題を
            <br />
            解決し未来を創造する
          </Typography>
          <Box sx={{ width: 60, height: 3, bgcolor: "white", mb: 4 }} />
          <Typography
            sx={{
              fontSize: { xs: "0.9rem", md: "1.1rem" },
              maxWidth: 600,
              lineHeight: 1.9,
              opacity: 0.92,
              mb: 5,
            }}
          >
            開発者の深い知見と熱意をもって、まだ顕在化していないシステムの潜在的な課題と価値を徹底的に「見つける」ことから全てが始まります。
          </Typography>
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate("/service")}
              sx={{
                bgcolor: "white",
                color: PRIMARY,
                fontWeight: 700,
                px: 4,
                py: 1.5,
                borderRadius: 0,
                "&:hover": { bgcolor: "#f5f5f5" },
              }}
            >
              サービスを見る
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={() => navigate("/company")}
              sx={{
                borderColor: "white",
                color: "white",
                fontWeight: 700,
                px: 4,
                py: 1.5,
                borderRadius: 0,
                "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
              }}
            >
              会社概要
            </Button>
          </Box>
        </Container>
      </Box>

      {/* Corporate Message */}
      <Box sx={{ bgcolor: "#1a1a1a", py: { xs: 6, md: 8 } }}>
        <Container maxWidth="lg">
          <Typography
            sx={{
              fontSize: { xs: "0.8rem", md: "0.9rem" },
              color: PRIMARY,
              fontWeight: 600,
              letterSpacing: 3,
              mb: 2,
            }}
          >
            Corporate Message
          </Typography>
          <Typography
            variant="h3"
            sx={{
              color: "white",
              fontWeight: 900,
              fontSize: { xs: "1.8rem", md: "2.8rem" },
            }}
          >
            繋ぎ、関わり、成長する
          </Typography>
        </Container>
      </Box>

      {/* Business Section */}
      <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: "#f8f8f8" }}>
        <Container maxWidth="lg">
          <Typography
            sx={{
              fontSize: "0.85rem",
              fontWeight: 600,
              letterSpacing: 3,
              color: PRIMARY,
              mb: 1,
            }}
          >
            Business
          </Typography>
          <Typography
            variant="h3"
            sx={{ fontWeight: 900, mb: 2, fontSize: { xs: "1.8rem", md: "2.5rem" } }}
          >
            事業内容
          </Typography>
          <Typography sx={{ color: "#666", mb: 6, maxWidth: 600 }}>
            「IT」と「SNS」を軸に、お客様の業務最適化と企業価値の最大化を両面から支援します。
          </Typography>
          <Grid container spacing={4}>
            {businessItems.map((item, i) => (
              <Grid item xs={12} md={6} key={i}>
                <Paper
                  elevation={0}
                  sx={{
                    p: { xs: 4, md: 5 },
                    height: "100%",
                    border: `2px solid ${PRIMARY}`,
                    borderRadius: 0,
                    position: "relative",
                    overflow: "hidden",
                    transition: "transform 0.2s",
                    "&:hover": { transform: "translateY(-4px)" },
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: 6,
                      height: "100%",
                      bgcolor: PRIMARY,
                    }}
                  />
                  <Box sx={{ pl: 1 }}>
                    <Typography sx={{ fontSize: "2rem", mb: 2 }}>{item.icon}</Typography>
                    <Typography
                      sx={{
                        fontSize: "0.8rem",
                        fontWeight: 700,
                        color: PRIMARY,
                        letterSpacing: 2,
                        mb: 1,
                      }}
                    >
                      {item.label}
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 800, mb: 2, fontSize: { xs: "1.1rem", md: "1.3rem" } }}
                    >
                      {item.title}
                    </Typography>
                    <Typography sx={{ color: "#555", lineHeight: 1.8, mb: 3 }}>
                      {item.description}
                    </Typography>
                    <Button
                      variant="text"
                      endIcon={<ArrowForwardIcon />}
                      onClick={() => navigate("/service")}
                      sx={{
                        color: PRIMARY,
                        fontWeight: 700,
                        p: 0,
                        "&:hover": { bgcolor: "transparent", opacity: 0.7 },
                      }}
                    >
                      詳しく見る
                    </Button>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* News Section */}
      <Box sx={{ py: { xs: 8, md: 12 } }}>
        <Container maxWidth="lg">
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              mb: 5,
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: "0.85rem",
                  fontWeight: 600,
                  letterSpacing: 3,
                  color: PRIMARY,
                  mb: 1,
                }}
              >
                News
              </Typography>
              <Typography
                variant="h3"
                sx={{ fontWeight: 900, fontSize: { xs: "1.8rem", md: "2.5rem" } }}
              >
                お知らせ
              </Typography>
            </Box>
            <Button
              variant="outlined"
              endIcon={<ArrowForwardIcon />}
              onClick={() => navigate("/news")}
              sx={{
                color: PRIMARY,
                borderColor: PRIMARY,
                borderRadius: 0,
                fontWeight: 700,
                display: { xs: "none", md: "flex" },
              }}
            >
              View All
            </Button>
          </Box>

          <Box>
            {newsItems.map((news, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  py: 2.5,
                  borderBottom: "1px solid #e0e0e0",
                  "&:first-of-type": { borderTop: "1px solid #e0e0e0" },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1.5 }}>
                  <Typography
                    sx={{ fontSize: "0.85rem", color: "#888", minWidth: 90 }}
                  >
                    {news.date}
                  </Typography>
                  <Typography
                    component="span"
                    sx={{
                      bgcolor: PRIMARY,
                      color: "white",
                      px: 1.5,
                      py: 0.3,
                      fontSize: "0.7rem",
                      fontWeight: 700,
                    }}
                  >
                    {news.category}
                  </Typography>
                  <Typography sx={{ fontSize: "0.95rem" }}>{news.title}</Typography>
                </Box>
                <IconButton size="small" sx={{ color: PRIMARY, ml: 1 }}>
                  <ArrowForwardIosIcon fontSize="inherit" />
                </IconButton>
              </Box>
            ))}
          </Box>

          <Box sx={{ mt: 4, display: { xs: "block", md: "none" }, textAlign: "center" }}>
            <Button
              variant="outlined"
              endIcon={<ArrowForwardIcon />}
              onClick={() => navigate("/news")}
              sx={{ color: PRIMARY, borderColor: PRIMARY, borderRadius: 0, fontWeight: 700 }}
            >
              View All
            </Button>
          </Box>
        </Container>
      </Box>

      {/* CTA Section */}
      <Box sx={{ bgcolor: PRIMARY, py: { xs: 8, md: 12 }, textAlign: "center" }}>
        <Container maxWidth="md">
          <Typography
            variant="h4"
            sx={{
              color: "white",
              fontWeight: 900,
              mb: 3,
              fontSize: { xs: "1.5rem", md: "2rem" },
            }}
          >
            まずはお気軽にご相談ください
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.85)", mb: 5, fontSize: "1rem" }}>
            システム開発・SNS運用に関するご質問・お見積もりはこちら
          </Typography>
          <Button
            variant="contained"
            size="large"
            sx={{
              bgcolor: "white",
              color: PRIMARY,
              fontWeight: 700,
              px: 6,
              py: 2,
              borderRadius: 0,
              fontSize: "1rem",
              "&:hover": { bgcolor: "#f0f0f0" },
            }}
          >
            お問い合わせ
          </Button>
        </Container>
      </Box>
    </Box>
  );
};

export default TopPage;
